import { useEffect } from 'react'

import {
  Control,
  FieldValues,
  UseFormSetValue,
  useWatch
} from 'react-hook-form'
import { createParam } from 'solito'

import { IS_SAFARI } from 'app/utils/constants/env.constants'

const { useParam } = createParam()

const usePaginationForm = ({
  setValue,
  control
}: {
  setValue?: UseFormSetValue<FieldValues>
  control?: Control<FieldValues, object>
}) => {
  const [p = ''] = useParam('p')
  const formPage = useWatch({ control, name: 'p' })

  const setPage = (page: number) => {
    if (setValue) setValue('p', page)

    if (IS_SAFARI) {
      window.scrollTo({ top: 0 })
    }

    if (!IS_SAFARI) {
      setTimeout(() => {
        window.scrollTo({ top: 0 })
      }, 0)
    }
  }

  useEffect(() => {
    if (+p !== +formPage && !isNaN(+formPage)) {
      setPage(Number(p) || 1)
    }
  }, [p])

  /* Initialize pagination page */
  useEffect(() => {
    if (p && +p > 1) {
      setPage(Number(p))
    }
  }, [])

  return { setPage, page: (formPage && Number(formPage)) || 1 }
}

export default usePaginationForm
